import React, { useEffect } from 'react'
import { MODAL_IDS } from '../../store/ui/ui.constants'
import Modal from '../genericComponents/Modal'
import useModal from '../ui/useModal'
import CritairChoice from './CritairChoice'
import s from './CritairChoice.less'
import { CRITAIR_DEFAULT_ID } from './ItineraryOptions.constants'

const CritairSelect = ({ critAirStickers = [], value = CRITAIR_DEFAULT_ID, modeId, onChange }) => {
  const critAirSticker = critAirStickers.find(({ id }) => id === value)
  const modalId = `${MODAL_IDS.CRITAIR}-${modeId}`
  const { displayModal, hideModal } = useModal(modalId)

  useEffect(() => hideModal, [])

  const onSelect = value => {
    onChange({ target: { value } })
    hideModal()
  }

  return (
    <>
      <div className={s.value} onClick={() => displayModal()}>
        {critAirSticker && <img src={critAirSticker.icon} />}
      </div>
      <Modal modalId={modalId} style={{ maxWidth: 360 }}>
        <CritairChoice critAirStickers={critAirStickers} onSelect={onSelect} value={value} />
      </Modal>
    </>
  )
}

export default CritairSelect
